import {ready} from '../main/utils';
import $ from 'jquery';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import Vue from '../main/vue';
import {history} from 'instantsearch.js/es/lib/routers';
import router from '../main/vue-routes';
import components from '../algolia';

const loadVideos = () => {
  if (document.querySelector('.videos')) {
    new Vue({
      el: '.videos',
      comments: true,
      components,
      data() {
        const indexName = this.$algolia.indexPrefix + 'videos';

        const routing = {
          router: history(),
          stateMapping: {
            stateToRoute(uiState) {
              const indexUiState = uiState[indexName] || {};
              return {
                query: indexUiState.query,
                video_type: indexUiState.menu?.video_type,
                product_type: indexUiState.menu?.product_type
              };
            },
            routeToState(routeState) {
              return {
                [indexName]: {
                  query: routeState.query,
                  menu: {
                    video_type: routeState.video_type,
                    product_type: routeState.product_type
                  }
                }
              };
            }
          }
        };

        return {
          indexName,
          routing,
          facets: ['video_type', 'product_type'],
          videoModalVisible: false,
          activeVimeoId: ''
        };
      },
      methods: {
        showVideo(vimeoId) {
          this.videoModalVisible = true;
          this.activeVimeoId = vimeoId;
        },

        hideVideo() {
          this.videoModalVisible = false;
          this.activeVimeoId = null;
        }
      },
      router
    });
  }
};

ready(() => {
  loadVideos();

  // Set up video modal
  $(document).on('show.bs.modal', '.video-modal', function() {
    $(this)
      .find('iframe')
      .attr(
        'src',
        '//player.vimeo.com/video/' +
        $(this).find('iframe').data('video-id') +
        '?autoplay=1'
      );
  });

  $(document).on('hidden.bs.modal', '.video-modal', function() {
    $(this).find('iframe').attr('src', '');
  });
});
